import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { VolumeCrudService } from 'src/app/shared/services/volume-crud.service';
import { Volume } from 'src/app/shared/interfaces/volume';

@Component({
  selector: 'app-volumes',
  templateUrl: './volumes.component.html',
  styleUrls: ['./volumes.component.scss']
})
export class VolumesComponent implements OnInit {

  volumes: Volume[];
  volume: Volume;
  selectedVolumes: Volume[] = [];

  volumeDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private volumeService : VolumeCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Barrel Management'},
      {label: 'Volumes'}
    ];

    this.volumes = [];
    this.volume = { } as Volume ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.volumeService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.volumes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Volume = jsonItem as Volume;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.volumes.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
   // this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.volumeService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.volumes);
            doc.save('volumes.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.volumes);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "volumes");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedVolumes);
      // console.log('SAVEC CSV LOCATIONS ', this.volumes);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedVolumes, 'volumes', exportCols);
   // this.exportService.exportToCsv(this.volumes, 'volumes', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.volume = {} as Volume;
    this.submitted = false;
    this.volumeDialog = true;
  }

  deleteSelectedVolumes() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected volumes?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.volumes = this.volumes.filter(val => !this.selectedVolumes.includes(val));
            
            this.selectedVolumes.forEach( volume => this.volumeService.delete(volume.$key));
            this.selectedVolumes = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Volumess Deleted', life: 3000});
        }
    });
  }

  editVolume(volume: Volume) {
    this.volume = {...volume};
    this.volumeDialog = true;
  }

  deleteVolume(volume: Volume) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + volume.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.volumes = this.volumes.filter(val => val.$key !== volume.$key);
            this.volume = {} as Volume;
            this.volumeService.delete(volume.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Volume Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.volumeDialog = false;
    this.submitted = false;
  }

  saveVolume() {
    this.submitted = true;

    if ( this.volume.name.trim() ) {
      this.volume.isEnabled = true;

      if (this.volume.$key) {
          this.volumes[this.findIndexById(this.volume.$key)] = this.volume;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Volume Updated', life: 3000});
          this.volumeService.update(this.volume);
        } else {
          this.volume.position = this.volumes.length;
          this.volumeService.add(this.volume);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Volume Created', life: 3000});
      this.volumes = [...this.volumes];
    }

    this.volumeDialog = false;
    this.volume = { } as Volume;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.volumes.length; i++) {
        if (this.volumes[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeVolume(volume : Volume) {
    //console.log("SAVE", volume);
    this.volumeService.update(volume);
  }

  completePosition(volume : Volume) {
   // console.log("SAVE", volume);
  //  this.volumeService.updateVolume(volume);


    if ( this.newPosition > -1 ) {
        volume.position = this.newPosition;
        volume = this.checkPositionLimits(volume);
        this.reorderElements(volume);
        //this.updateDB(volume);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.volumes);
    // const myClonedArray = [];
    // this.volumes.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.volumes.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.volumes.length - 1 - event.dropIndex;
    const volumeToMove = this.volumes[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.volumes[index] = this.volumes[index+1];
        this.volumes[index].position = index;
        this.volumeService.update(this.volumes[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.volumes[index] = this.volumes[index-1];
        this.volumes[index].position = index;
        this.volumeService.update(this.volumes[index]);
      }
    } 
    this.volumes[endIndex] = volumeToMove;
    this.volumes[endIndex].position = endIndex;
    this.volumeService.update(this.volumes[endIndex]);
  }

  // onFieldEdit(volume: Spray, fieldName: string): void {
  //   //console.log(this.volumes);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + volume[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       volume.position = this.newPosition;
  //       volume = this.checkPositionLimits(volume);
  //       this.reorderElements(volume);
  //       //this.updateDB(volume);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(volume);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.volumes.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, volume: Volume) {
    // console.log("event" +event);
    if (volume.position != null && volume.position > -1) {
      this.previousPosition = volume.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(volume: Volume) {
    console.log('check ',volume.position + ' ' + this.volumes.length);
    if (!volume.position) {
     // console.log('check 1');
      return this.volume;
    }
    if (volume.position < 0) {
      volume.position = 0;
      // console.log('check 2');
      return volume;
    }
    if (volume.position > this.volumes.length) {
      volume.position = this.volumes.length - 1;
    //  console.log('check 3', volume.position);
      return volume;
    }
   // console.log('check 4');
    return volume;
  }

  async reorderElements(volume: Volume) {
    this.newPosition = this.newPosition  > this.volumes.length ? this.volumes.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === volume.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const volumeToMove = this.volumes[startIndex];
   // console.log('Item to move: ', this.volumes[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.volumes);
        console.log('Item to +1: ', this.volumes[index+1]);

        this.volumes[index] = this.volumes[index+1];
        this.volumes[index].position = index;
        // console.log('Move: ', this.volumes[index+1]);
        // console.log('Move pos: ', this.volumes[index].position);
        //await this.updateDB(this.volumes[index]);
        this.volumeService.update(this.volumes[index]);
     //   console.log('Update DB: ', this.volumes[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.volumes[index] = this.volumes[index-1];
        this.volumes[index].position = index;
        this.volumeService.update(this.volumes[index]);
      }
    } 
    this.volumes[endIndex] = volumeToMove;
    this.volumes[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.volumeService.update(this.volumes[endIndex]);
    
    // const myClonedArray = [];
    // this.volumes.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.volumes = myClonedArray;
   // this.getAllRecords();
  }
}
